import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { map, toNumber, get, find,filter } from 'lodash';
import { Modal, Button, Toast } from 'react-bootstrap';
import NetworkHeartService from 'network-heart-service';
import Snipper from '../../../layout/Spinner/snipper.component';
import './wrapper-calculator.style.css';
// import TableCalculator from './table-calculator/table-calculator.component';
import ExportPDFCalculateTable from './table-calculator/table-calculator.component';
import { saveResutNRWCalculate } from '../../../../redux/general/action';
import { get4ContantParam, getTotalLengthDMA, getAveragePressurceWaterSupply, getTotalConnection, getBilledMeteredConsumptioin } from '../../../../api/calculate_table_DMA';
import { getListDMA } from '../../../../api/list_DMA';
import { postNRWTable, postNRWTableToGIS } from '../../../../api/nrw_table';
import { getToken } from '../../../../api/get_token';
import DatePicker from 'react-date-picker';
// import { dummyDataFillNRWTable, noDummyDataFillNRWTable } from './dummy_data'

export class WrapperCalculator extends Component {
    constructor(props) {
        super();
        this.state = {
            dateCal: new Date(),
            monthCal: moment(new Date()).format('MM'),
            yearCal: moment(new Date()).format('yyyy'),
            daysInMonth: moment().daysInMonth(),
            data: [],
            data4ConstantParam: [],
            dataTotalLengthDMA: [],
            dataAveragePressureWaterSupply: [],
            listDMA: [],
            loading: false,
            hasData: true,
            editedData: [],
            calculatedData: [],
            calculatedDataToSaveGIS: [],
            showModal: false,
            showToast: false,
            loading: false,
            loadingFillData: false,
            textInToast: '',
            textInModal: '',
            failColorToast: '#DCBF85',
            colorToast: '#F5F8DE'
        }
    }

    closeAlert = () => this.setState({ showModal: false });

    openAlert = () => this.setState({ showModal: true });

    closeToast = () => this.setState({ showToast: false });

    opentToast = () => this.setState({ showToast: true });

    onChange = dateInput => {
        const monthCal = moment(dateInput).format('MM');
        const yearCal = moment(dateInput).format('yyyy');
        const daysInMonth = moment(`${yearCal}-${monthCal}`,'YYYY-MM').daysInMonth();
        this.setState({ dateCal: dateInput, monthCal, yearCal,daysInMonth });
    }

    getEditValueFromChild = (dmaID, dataField, value) => {
        try {
            // console.log('dmaID-dataField-value: ',dmaID,dataField,value);
            const { data } = this.state;
            const updatedState = map(data, stateItem => {
                if (stateItem.dmaid === dmaID) {
                    stateItem[dataField] = toNumber(value);
                }
                return stateItem;
            });

            // console.log(updatedState);
            this.setState({ editedData: updatedState })
            return updatedState;
        } catch (error) {
            console.log('Error in get edit value from child: ', error);
        }
    }

    transformResultToFinal = (dataListDMA, data4ConstantParam, dataTotalLengthDMA, dataAveragePressureWaterSupply, dataGetTotalConnection, dataBilledMeteredConsumptioin, month, year) => {
        try {
            //get array DMA
            // console.log('dataBilledMeteredConsumptioin: ',dataBilledMeteredConsumptioin);
            const arrayDMAID = dataListDMA.map((element) => {
                return get(element, 'attributes.DMAID');
            });
            // console.log('arrayDMAID: ',arrayDMAID);
            //create object
            const finalResult = arrayDMAID.map((element) => {
                //set 4 constant
                let fourConstant = {};
                data4ConstantParam.map((element) => {
                    const code = get(element, 'attributes.CODE');
                    switch (code) {
                        case 'BILLED_UNMETER_CONSUMPTION':
                            fourConstant['bill_unmeter_consump'] = get(element, 'attributes.NAME');
                            break;
                        case 'UNBILLED_AUTHORISED_CONSUMPTION':
                            fourConstant['per_unbill_auth_cons'] = get(element, 'attributes.NAME');
                            break;
                        case 'UNAUTHORISED_CONSUMPTION':
                            fourConstant['per_unauth_cons'] = get(element, 'attributes.NAME');
                            break;
                        case 'CUSTOMER_METERING_INACCURACIES':
                            fourConstant['per_meter_inaccura'] = get(element, 'attributes.NAME');
                            break;
                        default:
                            fourConstant['unknown'] = get(element, 'attributes.NAME');
                    }
                    return ''
                });

                //get total length
                let totalLengthDMANoAttributeKey = dataTotalLengthDMA.map((element) => {
                    return { ...element.attributes }
                });
                let totalLengthObjectForThisDMA = find(totalLengthDMANoAttributeKey, { 'DMAID': element });

                //get average and water supply
                let averagePressWaterSupplyForThisDMA = find(dataAveragePressureWaterSupply, { 'idDMA': `${element}` })

                //get total connection
                // console.log("dataGetTotalConnection: ",dataGetTotalConnection);
                let totalConnectionNoAttributesKey = dataGetTotalConnection.map((element) => {
                    return { ...element.attributes }
                });
                // console.log('elementIDDMA: ',element);
               
                let totalConnectionObjectForThisDMA = find(totalConnectionNoAttributesKey, { 'DMAID': element });

                //get billed metered consumption
                let billedMeteredConsumptionForThisDMA = find(dataBilledMeteredConsumptioin, { 'idDMA': element })

                return {
                    'dmaid': element,
                    'total_connections': totalConnectionObjectForThisDMA ? toNumber(totalConnectionObjectForThisDMA['TotalConnection']) : '',
                    'total_length': totalLengthObjectForThisDMA ? toNumber(totalLengthObjectForThisDMA['TotalLenghtByDMA']).toFixed(2) : '',
                    'average_pressure': (averagePressWaterSupplyForThisDMA && averagePressWaterSupplyForThisDMA['avgPressure']) ? toNumber(averagePressWaterSupplyForThisDMA['avgPressure']) : '',
                    'water_supplied': (averagePressWaterSupplyForThisDMA && averagePressWaterSupplyForThisDMA['waterSupply']) ? (toNumber(averagePressWaterSupplyForThisDMA['waterSupply'])/this.state.daysInMonth).toFixed(0)  : '',
                    'bill_meter_consump': billedMeteredConsumptionForThisDMA ? (toNumber(billedMeteredConsumptionForThisDMA['billMeterConsumption'])/this.state.daysInMonth).toFixed(0)  : '',
                    'bill_unmeter_consump': toNumber(fourConstant['bill_unmeter_consump']),
                    'per_unbill_auth_cons': toNumber(fourConstant['per_unbill_auth_cons']),
                    'per_unauth_cons': toNumber(fourConstant['per_unauth_cons']),
                    'per_meter_inaccura': toNumber(fourConstant['per_meter_inaccura']),
                    'month': toNumber(month),
                    'year': toNumber(year)
                }
            });
            // console.log('finalResult', finalResult);
            return finalResult
        } catch (error) {
            console.log('Error in transformResultToFinal:', error);
        }
    }

    fillData = async () => {
        try {
            const isOnline = await NetworkHeartService.isOnline();
            if (!isOnline) {
                this.setState({ textInToast: 'Oh, may be you went offline, please check you connection!', colorToast: '#DCBF85' })
                this.opentToast();
                return;
            }

            this.setState({ loading: true });

            //get total length
            const resGetToken = await getToken();
            const token = resGetToken.data.token;
            const wherClauseGetTotalLengthDMA = `1=1 and MONTH=${this.state.monthCal} and YEAR=${this.state.yearCal}`;
            const resGetTotalLengthDMA = await getTotalLengthDMA(token, wherClauseGetTotalLengthDMA);

            if (!(Array.isArray(resGetTotalLengthDMA.data.features) && resGetTotalLengthDMA.data.features.length)) {
                this.setState({
                    hasData: false, loading: false,
                    data4ConstantParam: [],
                    dataTotalLengthDMA: []
                })
                this.setState({ textInToast: 'No data found!', colorToast: '#DCBF85' })
                this.opentToast();
                return;
            }
            //get total length
            const dataTotalLengthDMA = resGetTotalLengthDMA.data.features;
            // console.log('dataTotalLengthDMA:',dataTotalLengthDMA);

            //get list DMA
            const reslistDMA = await getListDMA(token, '');
            const dataListDMA = reslistDMA.data.features;
            this.setState({ listDMA: dataListDMA });

            const res4ContantParam = await get4ContantParam(token, '');
            const data4ConstantParam = res4ContantParam.data.features;
            // console.log('data4ConstantParam:',data4ConstantParam);

            //get average pressure and water supply
            // const token_scada_server = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImFkbWluIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy91c2VyZGF0YSI6Ilowb3F3enhGMmNqVUo4UjBrL1Ayd1E9PSIsIm5iZiI6MTU4NjkzODY5MywiZXhwIjoxNTg5NTMwNjkzLCJpYXQiOjE1ODY5Mzg2OTN9.Fl7U8-D9GeCvJQjS1bNCl5uw1XlDISZc8cyq5Teq-VQ'
            const token_scada_server = token;
            const paramInputMonthYear = { 'month': `${this.state.monthCal}`, 'year': `${this.state.yearCal}` }
            const resGetAveragePressurceWaterSupply = await getAveragePressurceWaterSupply(token_scada_server, paramInputMonthYear);
            const dataAveragePressureWaterSupply = resGetAveragePressurceWaterSupply.data.data;
            // console.log('dataAveragePressureWaterSupply',dataAveragePressureWaterSupply);
            // console.log('dataAveragePressureWaterSupply:',dataAveragePressureWaterSupply);

            //get total connection
            const resGetTotalConnection = await getTotalConnection(token, '');
            const dataGetTotalConnection = resGetTotalConnection.data.features;
            // console.log('dataGetTotalConnection:',dataGetTotalConnection);
           


            //get billed metered consumption
            // const paramToGetBilledMeteredConsumption = {'year': 2020, 'month':7};
            const resGetBilledMeteredConsumption = await getBilledMeteredConsumptioin(token_scada_server, paramInputMonthYear);
            const dataBilledMeteredConsumption = resGetBilledMeteredConsumption.data.data;
            // console.log('dataBilledMeteredConsumption:',dataBilledMeteredConsumption);


            const finalResult = this.transformResultToFinal(dataListDMA, data4ConstantParam,
                dataTotalLengthDMA, dataAveragePressureWaterSupply, dataGetTotalConnection, dataBilledMeteredConsumption, this.state.monthCal, this.state.yearCal);

            console.log('finalResult fill: ', finalResult);    
            
                this.setState({
                data: finalResult,
                hasData: true,
                loading: false
            });


        } catch (error) {
            console.log('Error in fill data', error);
        }
    }

    calculateData = async () => {
        try {
            let arraySource = []
            arraySource = this.state.editedData.length > 0 ? this.state.editedData : this.state.data;
            // console.log('arraySource', arraySource);
            // console.log('used data: ', arraySource);
            const updatedState = arraySource.map(dma => {
                //check value of average_pressure, water_supplied,bill_meter_consump
                if (dma.average_pressure === '') {
                    dma.average_pressure = -1;
                }

                if (dma.bill_meter_consump === '') {
                    dma.bill_meter_consump = -1;
                }
                if (dma.water_supplied === '' || dma.water_supplied == 0) {
                    dma.water_supplied = -1;
                }
                if (dma.total_connections === '') {
                    dma.total_connections = -1;
                }
                if (dma.total_length === '') {
                    dma.total_length = -1
                }

                //percent water supplied
                const percent_water_supplied = 100;
                //percent Billed Metered Consumption
                const per_bill_meter_cons = dma.bill_meter_consump / dma['water_supplied'] * 100;
                //percent Billed Unmetered Consumption (AVERAGE READING)
                const per_bill_unmet_cons = dma.bill_unmeter_consump / dma['water_supplied'] * 100;
                //Revenue Water
                const revenue_water = toNumber(dma.bill_meter_consump)  + toNumber(dma.bill_unmeter_consump);
                //percent revenue water
                const per_revenue_water = revenue_water / dma['water_supplied'] * 100;
                // Unbilled Metered Consumption (Tanker Supply, elephant trunk, public stand pipe, subsidary min volume usage by utilities)
                const unbill_meter_consump = 0;
                // percent Unbilled Metered Consumption (Tanker Supply, elephant trunk, public stand pipe, subsidary min volume usage by utilities)
                const per_unbill_met_cons = 0;
                //percent Unbilled Unmetered Consumption (Illegal usage-available stand meter but no meter)
                const per_unbill_unme_cons = dma.per_unbill_auth_cons;
                //Unbilled Unmetered Consumption (Illegal usage-available stand meter but no meter)
                const unbill_unmet_cons = dma.per_unbill_auth_cons * 0.01 * dma['water_supplied'];
                //Unbilled Authorised Consumption
                const unbill_auth_consump = dma.per_unbill_auth_cons * 0.01 * dma['water_supplied'];
                //NON-REVENUE WATER (NRW)
                const non_rev_water_nrw = dma['water_supplied'] - dma.bill_meter_consump - dma.bill_unmeter_consump;
                //percent NON-REVENUE WATER (NRW)
                const percent_nrw = non_rev_water_nrw / dma['water_supplied'] * 100;
                //Water Losses
                const water_losses = non_rev_water_nrw - unbill_auth_consump;
                //percent Water Losses
                const percent_water_loss = water_losses / dma['water_supplied'] * 100;
                //Authorised Consumption
                const auth_consump = dma['water_supplied'] - water_losses;
                //percent auth_consump
                const percent_auth_consump = auth_consump / dma['water_supplied'] * 100;
                //Billed Authorised Consumption
                const bill_auth_consump = auth_consump - unbill_auth_consump;
                //percent Billed Authorised Consumption
                const per_bill_auth_consump = bill_auth_consump / dma['water_supplied'] * 100;
                //Unauthorised Consumption (Illegal @ theft)
                const unauth_consump = dma.per_unauth_cons * 0.01 * dma['water_supplied'];
                //Customer Metering Inaccuracies
                const cus_meter_inaccura = dma.per_meter_inaccura * 0.01 * dma.bill_meter_consump
                //APPARENT LOSSES (Commercial)
                const app_losses = unauth_consump + cus_meter_inaccura;
                //percent APPARENT LOSSES (Commercial)
                const per_app_loss = app_losses / dma['water_supplied'] * 100;
                //CURRENT ANNUAL REAL LOSSES (CARL)
                const cur_an_real_loss = water_losses - app_losses;
                //PERCENT REAL LOSSES  CARL
                const per_real_loss = cur_an_real_loss / dma['water_supplied'] * 100;
                //PERCENT LEAKAGE ON TRANSMISSION
                const leak_trans = cur_an_real_loss * 0.3;
                //PERCENT LEAKAGE ON TRANSMISSION
                const per_leak_trans = leak_trans / dma['water_supplied'] * 100;
                //LEAKAGE ON SERVICES
                const leak_services = cur_an_real_loss * 0.7;
                //PERCENT LEAKAGE ON SERVICES
                const per_leak_services = leak_services / dma['water_supplied'] * 100;
                //UNAVOIDABLE ANNUAL REAL LOSSES (UARL)
                const unavo_an_real_loss = ((18 * dma.total_length * dma.average_pressure) + (0.8 * dma.total_connections * dma.average_pressure)) / 1000;
                //POTENTIALLY RECOVERABLE REAL LOSSES = (CARL - UARL)
                const pot_reco_real_loss = cur_an_real_loss - unavo_an_real_loss;
                //INFRASTRUCTURE LEAKAGE INDEX (ILI)
                const infras_leakage_index = cur_an_real_loss / unavo_an_real_loss;
                //month
                const month = this.state.monthCal;
                //year
                const year = this.state.yearCal;
                //lastupdated
                const lastupdated = moment(new Date()).format('YYYY-MM-DD hh:mm:ss');

                return {
                    ...dma,
                    'percent_water_supplied': percent_water_supplied,
                    'per_bill_meter_cons': per_bill_meter_cons,
                    'per_bill_unmet_cons': per_bill_unmet_cons,
                    'revenue_water': revenue_water,
                    'per_revenue_water': per_revenue_water,
                    'unbill_meter_consump': unbill_meter_consump,
                    'per_unbill_met_cons': per_unbill_met_cons,
                    'per_unbill_unme_cons': per_unbill_unme_cons,
                    'unbill_unmet_cons': unbill_unmet_cons,
                    'unbill_auth_consump': unbill_auth_consump,
                    'non_rev_water_nrw': non_rev_water_nrw.toFixed(0),
                    'percent_nrw': percent_nrw.toFixed(2),
                    'water_losses': water_losses,
                    'percent_water_loss': percent_water_loss,
                    'auth_consump': auth_consump,
                    'percent_auth_consump': percent_auth_consump,
                    'bill_auth_consump': bill_auth_consump,
                    'per_bill_auth_consump': per_bill_auth_consump,
                    'unauth_consump': unauth_consump,
                    'cus_meter_inaccura': cus_meter_inaccura,
                    'app_losses': app_losses,
                    'per_app_loss': per_app_loss,
                    'cur_an_real_loss': cur_an_real_loss,
                    'per_real_loss': per_real_loss,
                    'leak_trans': leak_trans,
                    'per_leak_trans': per_leak_trans,
                    'leak_services': leak_services,
                    'per_leak_services': per_leak_services,
                    'unavo_an_real_loss': unavo_an_real_loss,
                    'pot_reco_real_loss': pot_reco_real_loss,
                    'infras_leakage_index': infras_leakage_index,
                    'month': month,
                    'year': year,
                    'lastupdated': lastupdated
                }
            });

            // console.log('updatedState', updatedState);

            let dataToSave = updatedState.map(element => {
                return { "attributes": { ...element } }
            });

            console.log("dataToSave ", dataToSave);

            let listDMA = this.state.listDMA;
            let dataToSaveGIS = listDMA.map((element) => {
                let dataForOneDMA = find(updatedState, ['dmaid', get(element, 'attributes.DMAID')]);
                return {
                    'OBJECTID': element.attributes.OBJECTID,
                    'TOTAL_CONNECTIONS': dataForOneDMA.total_connections,
                    'TOTAL_LENGTH': toNumber(dataForOneDMA.total_length),
                    'WATER_SUPPLIED': dataForOneDMA.water_supplied,
                    'AVERAGE_PRESSURE': dataForOneDMA.average_pressure,
                    'BILL_METER_CONSUMP': dataForOneDMA.bill_meter_consump,
                    'NON_REV_WATER_NRW': dataForOneDMA.non_rev_water_nrw,
                    'PERCENT_NRW': dataForOneDMA.percent_nrw,
                    'WATER_LOSSES': dataForOneDMA.water_losses,
                    'PERCENT_WATER_LOSS': dataForOneDMA.percent_water_loss,
                    'YEAR': toNumber(this.state.yearCal),
                    'MONTH': toNumber(this.state.monthCal)
                }
            });

            console.log('dataToSaveGIS all: ', dataToSaveGIS);

              //with value less than 0 (<0) do not include in data to save
              let dataToSaveGISNoLessThanZero = filter(dataToSaveGIS,(item)=>{
                return (toNumber(item.TOTAL_CONNECTIONS) >= 0 && toNumber(item.TOTAL_LENGTH) >= 0 && toNumber(item.WATER_SUPPLIED) >= 0 && toNumber(item.AVERAGE_PRESSURE) >= 0 
                && toNumber(item.BILL_METER_CONSUMP) >= 0 && toNumber(item.NON_REV_WATER_NRW) >= 0 &&  toNumber(item.PERCENT_NRW) >= 0 && toNumber(item.WATER_LOSSES) >= 0 
                && toNumber(item.PERCENT_WATER_LOSS) >= 0)
            });

            //use this when need to add new
            // let dataToSaveGISFinal = dataToSaveGIS.map(element => {
            //     return { "attributes": { ...element } }
            // });

            let dataToSaveGISFinal = dataToSaveGISNoLessThanZero.map(element => {
                return { "attributes": { ...element } }
            });

            console.log('dataToSaveGISFinal nolesthanzero: ', dataToSaveGISFinal);

            // console.log('dataToSaveGISFinal', dataToSaveGISFinal);

            // console.log('dataToSaveGISFinal: ', JSON.stringify(dataToSaveGISFinal));
            this.setState({ calculatedData: dataToSave });
            this.setState({ calculatedDataToSaveGIS: dataToSaveGISFinal });
            // this.setState({ textInToast: 'Done, your data ready to save!', colorToast: '#F5F8DE' })
            // this.opentToast();
            this.setState({ textInModal: 'Done, your data ready to save!' }, () => {
                this.openAlert();
            })

            return dataToSave;
        } catch (error) {
            console.log('Error in calculate: ', error);
        }
    }

    saveData = async () => {
        try {
            const isOnline = await NetworkHeartService.isOnline();
            if (!isOnline) {
                this.setState({ textInToast: 'Oh, may be you went offline, please check you connection!', colorToast: '#DCBF85' })
                this.opentToast();
                return;
            }

            if (this.state.calculatedData.length > 0) {
                this.setState({ loading: true });

                const resGetToken = await getToken();
                const token = resGetToken.data.token;
                console.log('data save before save: ', this.state.calculatedData);
                const resPostNRWTable = await postNRWTable(token, this.state.calculatedData);
                console.log('data save before da save: ', this.state.calculatedData);

                this.setState({ loading: false })

                //update to redux store, I will use this data help to search in map component
                this.props.saveResutNRWCalculate(this.state.calculatedData);

                // this.setState({ textInToast: 'Done, your data saved!' }, () => {
                //     this.opentToast();
                // })



                const resPosstNRWTableToGIS = await postNRWTableToGIS(token, this.state.calculatedDataToSaveGIS);
                this.setState({ textInModal: 'Done, your data updated and saved!' }, () => {
                    this.openAlert();
                })



                // console.log('result: ', resPostNRWTable.statusText);


            } else {
                this.setState({ textInModal: 'Wait, please fill and  calculate your data first!' }, () => {
                    this.openAlert()
                });
            }

        } catch (error) {

        }
    }

    componentDidMount = async () => {
        try {
            // const response = await getCalcTable({
            //     thoigian: 'thang6'
            // })
            // const { data } = response
            // console.log('data', data)
        } catch (e) {
            //handle error
        }
    }

    render() {
        return (
            <div className="wrapper-calculator">
                <div className="container-name-calculator-table-and-export-excel-button">
                    <h1 className="name-element-total-box">Calculator table</h1>

                    <div className="wrapper-button-action">
                        <p className="text-des-search-calculator-table">Type month and year to calculate</p>
                        <div className="wrapper-seach-calculator-table">
                            <DatePicker
                                onChange={this.onChange}
                                value={this.state.dateCal}
                                className="date-picker-calculator"
                                maxDetail="year"
                            />
                        </div>
                        <button className="btn-calculator-table w-button" onClick={this.fillData}>Fill</button>
                        <button className="btn-calculator-table w-button" onClick={this.calculateData}>Calculate</button>
                        <button className="btn-calculator-table save-button w-button" onClick={this.saveData}>Save</button>
                    </div>
                    {/* <button className="button-export-excel w-button">Export to excel</button> */}
                    
                </div>
                <div className="container-calculator-table">
                    {/* <TableCalculator data={this.state.data}
                        hasData={this.state.hasData}
                        loadingFillData={this.state.loading}
                        sendEditValueToParent={this.getEditValueFromChild}
                    ></TableCalculator> */}

                    <ExportPDFCalculateTable data={this.state.data}
                        hasData={this.state.hasData}
                        loadingFillData={this.state.loading}
                        sendEditValueToParent={this.getEditValueFromChild}
                    ></ExportPDFCalculateTable>
                </div>

                {/* <div>
                    <div className="note-calculate-table">
                        <p className="note-text-calculate-table">Please follow these step: Fill -&gt; Calculate -&gt; Save</p>
                    </div>
                </div> */}

                <>
                    <Modal show={this.state.showModal} onHide={this.closeAlert}>
                        <Modal.Header closeButton>
                            <Modal.Title>NRW Management</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{this.state.textInModal}</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.closeAlert}>
                                Got it!
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>

                <div style={{
                    position: 'fixed',
                    bottom: '10px',
                    right: '2px',
                }}>
                    <Toast onClose={this.closeToast} show={this.state.showToast} delay={3000} autohide>
                        <Toast.Header>
                            <img
                                // src="holder.js/20x20?text=%20"
                                className="rounded mr-2"
                                alt=""
                            />
                            <strong className="mr-auto">NRW Management</strong>
                            {/* <small>11 mins ago</small> */}
                        </Toast.Header>
                        <Toast.Body style={{ backgroundColor: `${this.state.colorToast}` }}>{this.state.textInToast}</Toast.Body>
                    </Toast>
                </div>

                {this.state.loading ?
                    (<div style={{
                        position: 'fixed',
                        top: '50%',
                        right: '50%',
                    }}>
                        <Snipper /></div>) : (<></>)}
            </div>

        )
    }
}

const mapStateToProps = state => ({
    resultCalculate: get(state, 'GeneralStore.resultCalculate')
})

const mapDispatchToProps = dispatch => {
    return {
        saveResutNRWCalculate: resultCalculate => {
            dispatch(saveResutNRWCalculate(resultCalculate))
        }
    }
}

// export default WrapperCalculator
export default connect(mapStateToProps, mapDispatchToProps)(WrapperCalculator)
